import { post, get, del, put } from "../../http";
import { root } from "../../config.json";

export const getChartInfo = () => {
  return get(`${root}/api/v1/patient/chart`);
};
